
    <div class="demo">
      Thanks for trying the Passit demo!
      <span class="u-responsive-break">Data will be deleted daily.</span>
    </div>
  